export const pricing = [
    {
        title: "Personal",
        price: "60.99",
        space: "100 GB Disk Space",
        domains: "2 Sub domains",
        license: "No License",
        email_account: "5 Email Accounts",
        technical_support: "Phone & Mail Support"

    },
    {
        title: "Business",
        price: "35.99",
        space: "100 GB Disk Space",
        domains: "2 Sub domains",
        license: "No License",
        email_account: "5 Email Accounts",
        technical_support: "Phone & Mail Support"

    },
    {
        title: "Enterprise",
        price: "90.99",
        space: "100 GB Disk Space",
        domains: "2 Sub domains",
        license: "No License",
        email_account: "5 Email Accounts",
        technical_support: "Phone & Mail Support"
    },
]